import React from 'react';

const About = () => {
    return (
        <div className="bg-white">
            {/* Banner Section */}
            <div
                className="relative h-[400px] w-full bg-cover bg-center flex items-center justify-center"
                style={{ backgroundImage: "url('/banner1.jpg')" }}
            >
                <div className="absolute inset-0 bg-blue-900/70 flex items-center justify-center">
                    <h1 className="text-5xl font-bold text-white">About Our Company</h1>
                </div>
            </div>

            {/* Content Section */}
            <div className="max-w-5xl mx-auto px-6 py-16 text-gray-800">
                <h2 className="text-3xl font-bold text-blue-900 mb-6">Who We Are</h2>
                <p className="text-lg leading-relaxed mb-8">
                    Likai EV India Pvt. Ltd. (LEV India) is a premier end-to-end Aerial Cable Accessories
                    Manufacturing Company. We stand out as one of the few elite industry players capable
                    of providing fully integrated solutions, seamlessly managing everything from advanced
                    manufacturing and rigorous quality testing to specialized packaging and turnkey logistics.
                </p>

                <div className="grid md:grid-cols-2 gap-10 mb-12">
                    <div className="bg-blue-50 p-8 rounded-xl">
                        <h3 className="text-xl font-bold text-blue-900 mb-4">Our Robust Portfolio</h3>
                        <p>
                            We span both Type-1 and Type-3 All-Dielectric Self-Supporting (ADSS) cable accessories.
                            Our range includes Type-3 (Thermoplastic) products like Anchor/Suspension Clamps,
                            and high-tensile Type-1 (Preformed Helical Type) solutions like Terminal Helices
                            and Armor Grips.
                        </p>
                    </div>
                    <div className="bg-blue-50 p-8 rounded-xl">
                        <h3 className="text-xl font-bold text-blue-900 mb-4">Engineering Excellence</h3>
                        <p>
                            Our specialty lies in strict engineering compliance, with Type-1 helical solutions
                            fully type-approved under TEC 87060:2024 standards. We serve telecom and power
                            infrastructure giants with Pan-India network rollouts.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;